<template>
  <div>
    <b-select
      ref="select"
      :value="value"
      :size="size"
      :multiple="multiple"
      :filterable="filterable"
      :disabled="disabled"
      @change="change($event)"
      style="width: 100%"
    >
      <b-select-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></b-select-option>
      <template v-slot:first>
        <b-select-option :value="null" disabled>-- 请选择 --</b-select-option>
      </template>
    </b-select>
  </div>
</template>

<script>
import { request } from '@/api/service'

export default {
  name: 'bv-select',
  data () {
    return {
      options: [],
      svalue: '',
      selected: {}
    }
  },
  computed: {
    // selected () {
    //   let value = this.$refs.select.value
    //   console.log(value)
    //   let selected = this.options.filter(item => item.value === value)
    //   return selected && selected.length > 0 ? selected[0] : ''
    // }
  },
  methods: {
    change: function (val) {
      this.$emit('input', val)
      let selected = this.options.filter(item => item.value === val)
      this.selected = selected && selected.length > 0 ? selected[0] : ''
    },
    init () {
      // 初始话下拉框的值
      this.svalue = this.value
      // 远程请求回来的数据
      request({
        url: this.url,
        method: 'post',
        data: this.params
      }).then(res => {
        this.options = this._dataTransform(res.body.data)
      })
    },
    // 转换下拉框下的字段
    _dataTransform (data) {
      let _data = []
      if (this.fileType === null || this.fileType === undefined) {
        return data
      }
      for (let i = 0; i < data.length; i++) {
        _data[i] = {}
        _data[i].label = data[i][this.fileType.label]
        _data[i].value = data[i][this.fileType.value]
      }
      return _data
    }
  },
  watch: {
    // 判断下拉框的值是否有改变
    svalue (val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', this.svalue)
      }
    },
    body () {
      this.init()
    }
  },
  props: {
    placeholder: {
      default: '请选择',
      type: String
    },
    size: {
      default: 'md',
      type: String
    },
    filterable: {
      default: false,
      type: Boolean
    },
    clearable: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    multiple: {
      default: false,
      type: Boolean
    },
    url: {
      default: '/common/dict/system',
      type: String
    },
    value: {
      type: String
    }, // 接受外部v-model传入的值
    fileType: {
      type: Object
    }, // 定义请求回来的json数据格式
    body: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  created () {
    this.init()
  }
}
</script>
